import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Address, BillingAccount, DataCustomerAffiliate, DataCustomerBOperator, DataCustomerCountry, DataCustomerDepartment, DataCustomerHq, DataCustomerLeadOperator } from '../creazione-nuovo-customer/creazione-nuovo-customer-costants';

@Component({
  selector: 'app-customer-department',
  templateUrl: './customer-department.component.html',
  styleUrls: ['./customer-department.component.css']
})
export class CustomerDepartmentComponent implements OnInit {

  @Input() customerDto: DataCustomerLeadOperator;

  @Input() tendinaAgreements: any[];

  @Output() changeCreationStepCustomerDepartmentItemEvent = new EventEmitter<string>();

  @Output() updateCustomerDataDepartmentItemEvent = new EventEmitter<DataCustomerLeadOperator>();

  @Output() saveCustomerDepartmentEvent = new EventEmitter<DataCustomerLeadOperator>();

  @Output() previousStepEvent = new EventEmitter<string>();

  listCountry: DataCustomerCountry[] = [];

  listBOperator: DataCustomerBOperator[] = [];
  ngOnDestroy: () => void;



  constructor() { }

  ngOnInit(): void {
    this.initializeFormCustomerDepartmentCountry();
  }

  initializeFormCustomerDepartmentCountry() {
    this.listBOperator = this.customerDto ? this.customerDto.listBOperator : [];
    for (let operatorB of this.listBOperator) {
      if (operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let country of operatorB.listCountry) {
          if (country.listAffiliate.length > 0) {
            for (let affiliate of country.listAffiliate) {
              if (affiliate.listDepartment.length == 0) {
                let department: DataCustomerDepartment = {
                  affiliateId: affiliate.affiliateId,
                  departmentName: '',
                  departmentId: '',
                  customerBillingAccount: [{
                    id: '',
                    address: {
                      name: '',
                      city: '',
                      country: '',
                      postCode: '',
                      streetName: '',
                      streetNr: '',
givenName: '',
title: ''
                    }
                  }],
                  deliveryAddress: {
                    name: '',
                    city: '',
                    country: '',
                    postCode: '',
                    streetName: '',
                    streetNr: '',
givenName: '',
title: ''
                  },
                  localAgreement: affiliate.localAgreement,
                  operator: affiliate.operator,
                  globalCustomerId:affiliate.globalCustomerId
                }
                affiliate.listDepartment.push(department);
              } else {


                for (let dep of affiliate.listDepartment) {
                  if (!dep.customerBillingAccount) {
                    let arr: BillingAccount[] = [
                      {
                        id: '',
                        address: {
                          name: '',
                          city: '',
                          country: '',
                          postCode: '',
                          streetName: '',
                          streetNr: '',
givenName: '',
title: ''
                        }
                      }
                    ];
                    dep.customerBillingAccount = arr;
                  } else {
                    for (let acc of dep.customerBillingAccount) {
                      if (!acc.address) {
                        acc.address = {
                          name: '',
                          city: '',
                          country: '',
                          postCode: '',
                          streetName: '',
                          streetNr: '',
givenName: '',
title: ''
                        }
                      }
                    }
                  }
                  if (!dep.deliveryAddress) {
                    dep.deliveryAddress = {
                      name: '',
                      city: '',
                      country: '',
                      postCode: '',
                      streetName: '',
                      streetNr: '',
givenName: '',
title: ''
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  }



  backToStepCustomerAffiliate() {
    this.updateCustomerDepartmentData();
    this.previousStepEvent.emit("customer-data-affiliate");
  }

  updateCustomerDepartmentData() {
    if (this.listBOperator.length > 0) {
      this.customerDto.listBOperator = this.listBOperator;
    }
    this.updateCustomerDataDepartmentItemEvent.emit(this.customerDto);
  }

  resetForm() {
    for (let operatorB of this.listBOperator) {
      if (operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let elem of operatorB.listCountry) {
          if (elem.listAffiliate.length > 0) {
            for (let affiliate of elem.listAffiliate) {
              if (affiliate.listDepartment.length > 0) {
                for (let department of affiliate.listDepartment) {
                  department.departmentId = '';
                  department.departmentName = '';
                  department.customerBillingAccount = [{
                    id: '',
                    address: {
                      name: '',

                      city: '',
                      country: '',
                      postCode: '',
                      streetName: '',
                      streetNr: '',
givenName: '',
title: ''
                    }
                  }];
                  department.deliveryAddress = {
                    name: '',

                    city: '',
                    country: '',
                    postCode: '',
                    streetName: '',
                    streetNr: '',
givenName: '',
title: ''
                  };
                  department.localAgreement = affiliate.localAgreement;
                  department.operator = operatorB.bOperator
                }
              }
            }
          }
        }
      }
    }
  }

  customerDataDepartmentFormDisabled() {
    let result: boolean = false;
    let numOfDepartment: number = 0;
    for (let operatorB of this.listBOperator) {
      if (operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let elem of operatorB.listCountry) {
          if (elem.listAffiliate.length > 0) {
            for (let affiliate of elem.listAffiliate) {
              if (affiliate.listDepartment.length > 0) {
                for (let department of affiliate.listDepartment) {
                  numOfDepartment++;
                  if (!department.departmentId
                    || !department.deliveryAddress || !department.departmentName) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }

    if (numOfDepartment == 0) {
      return true;
    }

    return result;
  }

  saveCustomer() {
    this.updateCustomerDepartmentData();
    this.saveCustomerDepartmentEvent.emit(this.customerDto);
  }

  getCountryName(country?: DataCustomerCountry) {
    if (country && !country.countryName) {
      return "Country";
    } else if (country && country.countryName) {
      return "Country " + country.countryName;
    } else {
      return "";
    }
  }

  getAffiliateName(affiliate: DataCustomerAffiliate) {
    if (affiliate.affiliateId) {
      return "Affiliate " + affiliate.affiliateName + " ( " + affiliate.affiliateId + " )";

    } else {
      return "Affiliate " + affiliate.affiliateName;

    }

  }

  getDepartmentName(department: DataCustomerDepartment) {
    if (department.departmentId) {
      return "Department " + department.departmentName + " ( " + department.departmentId + " )";

    } else {
      return "Department " + department.departmentName;

    }
  }

  viewAddDepartmentZeroDepartment(affiliate: DataCustomerAffiliate) {
    if (affiliate.listDepartment.length == 0) {
      return true;
    } else {
      return false;
    }


  }

  viewAddDepartment(affiliate: DataCustomerAffiliate, department: DataCustomerDepartment) {
    let index = affiliate.listDepartment.indexOf(department);
    if (index == (affiliate.listDepartment.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  addDepartmentToAffiliate(affiliate: DataCustomerAffiliate) {
    let data: DataCustomerDepartment = {
      affiliateId: affiliate.affiliateId,
      customerBillingAccount: [{
        id: '',
        address: {
          name: '',
          city: '',
          country: '',
          postCode: '',
          streetName: '',
          streetNr: '',
givenName: '',
title: ''
        }
      }],
      deliveryAddress: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
givenName: '',
title: ''
      },
      departmentName: '',
      localAgreement: affiliate.localAgreement,
      departmentId: '',
      operator: affiliate.operator,
      globalCustomerId:affiliate.globalCustomerId
    }
    affiliate.listDepartment.push(data);
  }





  removeDepartment(affiliate: DataCustomerAffiliate, department: DataCustomerDepartment) {
    let index = affiliate.listDepartment.indexOf(department);
    affiliate.listDepartment.splice(index, 1);
  }









  addBillingAccount(department: DataCustomerDepartment) {
    let data: BillingAccount = {
      id: '',
      address: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
givenName: '',
title: ''
      }
    };
    department.customerBillingAccount.push(data);
  }

  viewAddBillingAccount(account: BillingAccount, department: DataCustomerDepartment) {
    let index = department.customerBillingAccount.indexOf(account);
    if (index == (department.customerBillingAccount.length - 1)) {
      return true;
    } else {
      return false;
    }
  }





  removeBillingAccount(department: DataCustomerDepartment, billingAccount: BillingAccount) {
    let index = department.customerBillingAccount.indexOf(billingAccount);
    department.customerBillingAccount.splice(index, 1);
  }



  viewAddBillingAccountZeroBillingAccount(department: DataCustomerDepartment) {
    if (department.customerBillingAccount && department.customerBillingAccount.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  getBOperatorId(bOperator: DataCustomerBOperator) {
    if (bOperator && !bOperator.bOperator) {
      return "B Operator";
    } else if (bOperator && bOperator.bOperator) {
      return "B Operator " + bOperator.bOperator;
    } else {
      return "";
    }
  }

  isDisableLocalAgreement(affiliate: DataCustomerAffiliate) {
    if (affiliate.localAgreement) {
      return true;
    } else {
      return false;
    }

  }





}

